/**
 * @generated SignedSource<<c8d3d276c7798edc3fcf1b41b316cb36>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserHandle_member$data = {
  readonly email: string;
  readonly id: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"UserAvatar_member" | "UserInfoPopover_member">;
  readonly " $fragmentType": "UserHandle_member";
};
export type UserHandle_member$key = {
  readonly " $data"?: UserHandle_member$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserHandle_member">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserHandle_member",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UserAvatar_member"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UserInfoPopover_member"
    }
  ],
  "type": "Member",
  "abstractKey": null
};

(node as any).hash = "97bd34ce157b9fb3226c97f3490d6cf0";

export default node;
